module.exports = __webpack_public_path__ + "static/img/m2.be356b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/m2.jpg
// module id = Kilm
// module chunks = 1